import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "toggleButton", "counter", "submitButton"]

  connect() {
    this.updateCount()
  }

  toggleAll() {
    const allChecked = this.checkboxTargets.every((cb) => cb.checked)
    this.checkboxTargets.forEach((cb) => (cb.checked = !allChecked))
    this.updateCount()
  }

  updateCount() {
    const total = this.checkboxTargets.length
    const checked = this.checkboxTargets.filter((cb) => cb.checked).length

    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${checked}/${total}`
    }

    if (this.hasToggleButtonTarget) {
      const allChecked = checked === total
      const selectAllText = this.toggleButtonTarget
        .closest("[data-controller]")
        .querySelector("[data-select-all-label]")?.dataset?.selectAllLabel
      const deselectAllText = this.toggleButtonTarget
        .closest("[data-controller]")
        .querySelector("[data-deselect-all-label]")?.dataset?.deselectAllLabel

      if (allChecked) {
        this.toggleButtonTarget.textContent = deselectAllText || "Alle abwählen"
      } else {
        this.toggleButtonTarget.textContent = selectAllText || "Alle auswählen"
      }
    }

    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = checked === 0
    }
  }
}
